(function () {
  var PRODUCTS = {
    "12210269192510": {
      variants: [
        { qty: 1, id: "53418582638910", price: 110 },
        { qty: 2, id: "53418582671678", price: 210 },
        { qty: 3, id: "53418582704446", price: 300 },
        { qty: 6, id: "53418582737214", price: 585 }
      ]
    },
    "12210347573566": {
      variants: [
        { qty: 1, id: "53418581492030", price: 110 },
        { qty: 2, id: "53418581524798", price: 210 },
        { qty: 3, id: "53418581557566", price: 300 },
        { qty: 6, id: "53418581590334", price: 585 }
      ]
    }
  };
  var SELLING_PLAN_ID = "18708398398";
  var UNIT_PRICE = 110;
  var SUB_DISCOUNT = 0.15;

  function money(n) {
    return "RM" + n.toFixed(2);
  }

  function subPriceOf(bundlePrice) {
    return Math.round(bundlePrice * (1 - SUB_DISCOUNT) * 100) / 100;
  }

  function buildTypeCards(variants, qty, type) {
    var variant = variants.filter(function (v) { return v.qty === qty; })[0];
    var original = qty * UNIT_PRICE;
    var oncePrice = variant.price;
    var subPrice = subPriceOf(oncePrice);
    return '' +
      '<button type="button" class="mofu-ptb__type-btn' + (type === "once" ? " is-active" : "") + '" data-type="once">' +
        '<span class="mofu-ptb__type-label">One-time purchase</span>' +
        '<span class="mofu-ptb__type-price">' +
          (oncePrice < original ? '<span class="mofu-ptb__type-was">' + money(original) + '</span>' : '') +
          '<span class="mofu-ptb__type-now">' + money(oncePrice) + '</span>' +
        '</span>' +
      '</button>' +
      '<button type="button" class="mofu-ptb__type-btn' + (type === "sub" ? " is-active" : "") + '" data-type="sub">' +
        '<span class="mofu-ptb__type-label">Subscribe &amp; save 15%</span>' +
        '<span class="mofu-ptb__type-price">' +
          (subPrice < original ? '<span class="mofu-ptb__type-was">' + money(original) + '</span>' : '') +
          '<span class="mofu-ptb__type-now">' + money(subPrice) + '<small>/mo</small></span>' +
        '</span>' +
      '</button>';
  }

  function buildQtyGrid(variants, qty) {
    var html = "";
    variants.forEach(function (v) {
      html += '<button type="button" class="mofu-ptb__qty-btn' + (v.qty === qty ? " is-active" : "") + '" data-qty="' + v.qty + '">' + v.qty + '</button>';
    });
    return html;
  }

  function init() {
    var infoEl = document.querySelector("product-info[data-id]");
    if (!infoEl) return;
    var productId = infoEl.getAttribute("data-id");
    var data = PRODUCTS[productId];
    if (!data) return;

    var formEl = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!formEl) return;
    var variantInput = formEl.querySelector("input.product-variant-id") || formEl.querySelector('input[name="id"]');
    if (!variantInput) return;
    var anchor = formEl.querySelector(".product-form-buttons");
    if (!anchor) return;

    var sellingPlanInput = document.createElement("input");
    sellingPlanInput.type = "hidden";
    sellingPlanInput.name = "selling_plan";
    sellingPlanInput.disabled = true;
    formEl.appendChild(sellingPlanInput);

    var widget = document.createElement("div");
    widget.className = "mofu-ptb";
    widget.innerHTML =
      '<div class="mofu-ptb__type"></div>' +
      '<div class="mofu-ptb__heading">Quantity</div>' +
      '<div class="mofu-ptb__qty"></div>';
    anchor.insertAdjacentElement("beforebegin", widget);

    var typeEl = widget.querySelector(".mofu-ptb__type");
    var qtyEl = widget.querySelector(".mofu-ptb__qty");

    var state = { type: "once", qty: 1 };

    function applyToForm() {
      var variant = data.variants.filter(function (v) { return v.qty === state.qty; })[0];
      if (variant) variantInput.value = variant.id;
      if (state.type === "sub") {
        sellingPlanInput.value = SELLING_PLAN_ID;
        sellingPlanInput.disabled = false;
      } else {
        sellingPlanInput.value = "";
        sellingPlanInput.disabled = true;
      }
    }

    function render() {
      typeEl.innerHTML = buildTypeCards(data.variants, state.qty, state.type);
      Array.prototype.forEach.call(typeEl.querySelectorAll(".mofu-ptb__type-btn"), function (btn) {
        btn.addEventListener("click", function () {
          state.type = btn.getAttribute("data-type");
          applyToForm();
          render();
        });
      });

      qtyEl.innerHTML = buildQtyGrid(data.variants, state.qty);
      Array.prototype.forEach.call(qtyEl.querySelectorAll(".mofu-ptb__qty-btn"), function (btn) {
        btn.addEventListener("click", function () {
          state.qty = parseInt(btn.getAttribute("data-qty"), 10);
          applyToForm();
          render();
        });
      });

      applyToForm();
    }

    render();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
